<tilby-dialog-toolbar mat-dialog-title title="APPLICATION.DEMO.TITLE" [hideConfirm]="true"/>

<tilby-dialog-content>
    <div class="tw-flex tw-flex-row tw-gap-6">
        <img class="tw-size-32 tw-min-w-32 tw-rounded-full tw-object-cover"
             [src]="'assets/images/demo/' + operator.imageName + '.jpg'"
             [alt]="operator.name" />
        <div class="tw-flex tw-flex-col">
            <span>{{ 'APPLICATION.DEMO.HELLO' | translate: { userName: data.userName } }}</span>
            <span>{{ 'APPLICATION.DEMO.PARAGRAPH_1' | translate }}</span>
            <span class="tw-mb-4">{{ 'APPLICATION.DEMO.PARAGRAPH_2' | translate }}</span>
            <span class="tw-mb-4">{{ 'APPLICATION.DEMO.PARAGRAPH_3' | translate }}</span>
            <span class="tw-mb-4">{{ 'APPLICATION.DEMO.PARAGRAPH_4' | translate }}</span>
            <span>{{ operator.name }}</span>
            <span><a [href]="'mailto:' + operator.email">{{ operator.email }}</a> - 011 070 1550</span>
        </div>
    </div>
</tilby-dialog-content>
